class NcMultiImageCtaAnimation extends HTMLElement {
  constructor() {
    super();
    this.animationHasRun = false;
    this.preheader = this.querySelector('.nc-multi-image-cta__preheader'); // The "Material library 0%"-text
    this.text1 = this.querySelector('.nc-multi-image-cta__preheader-text--1');
    this.text2 = this.querySelector('.nc-multi-image-cta__preheader-text--2');
    const options = {
      root: this.observerRoot,
      threshold: 0.75,
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (this.animationHasRun === false) {
            this.animationHasRun = true;
            this.initAnimation();
          }
        }
      });
    }, options);
    observer.observe(this);
  }

  counterAnimation() {
    const style = document.createElement('style');
    let keyframeStyling = '';
    for (let i = 1; i < 101; i++) {
      keyframeStyling += `
      ${i}% {
        counter-increment: cta-counter ${i};
      }
      `;
    }

    let imagesTotal = '';
    if (window.matchMedia('(min-width: 750px)').matches) {
      imagesTotal = 12;
    } else {
      imagesTotal = 8;
    }

    const root = document.documentElement;
    const msPerImage = parseInt(getComputedStyle(root).getPropertyValue('--nc-multi-cta-show-duration'));
    const msForAllImages = msPerImage * imagesTotal;
    const preheaderAnimationDuration = parseFloat(getComputedStyle(root).getPropertyValue('--nc-multi-cta-preheader-animation-duration')) * 1000; //get it in ms
    const preheaderAnimationDelay = parseFloat(getComputedStyle(root).getPropertyValue('--nc-multi-cta-preheader-animation-delay')) * 1000; //get it in ms
    const counterAnimationDelay = preheaderAnimationDuration + preheaderAnimationDelay;

    style.innerHTML = `
    .nc-multi-image-cta__preheader-text--2 {
      animation: cta-counter ${msForAllImages}ms forwards ${counterAnimationDelay}ms;
    }
    @keyframes cta-counter {
      ${keyframeStyling}
    }
    `;
    document.head.appendChild(style);
  }

  async initAnimation() {
    this.counterAnimation();
    await this.preheaderAnimation(); // animation step 1
    await this.showItemsAnimation(); // animation step 2
    await this.positionItemsAnimation(); // animation step 3
  }
  async preheaderAnimation() {
    return new Promise((resolve) => {
      this.preheadersub = this.preheader.querySelector('div');

      const myCallback = () => {
        this.preheadersub.removeEventListener('transitionend', myCallback);
        resolve(true);
      };

      // when animation is done, resolve Promise, so you can get back and start next animation
      this.preheadersub.addEventListener('transitionend', myCallback);

      // calculate placement of text on desktop
      if (window.matchMedia('(min-width: 750px)').matches) {
        const outerWidth = this.text1.parentElement.offsetWidth;
        const innerWidth1 = this.text1.offsetWidth;
        const innerWidth2 = this.text2.offsetWidth;
        const translate1 = (outerWidth - innerWidth1) / 2;
        const translate2 = (outerWidth - innerWidth2) / 2;
        const root = document.documentElement;
        root.style.setProperty('--nc-multi-image-cta-preheader-item-1-text-translate', '-' + translate1 + 'px');
        root.style.setProperty('--nc-multi-image-cta-preheader-item-2-text-translate', translate2 + 'px');
      }
      this.preheader.classList.add('nc-multi-image-cta__preheader--animate');
    });
  }
  async showItemsAnimation() {
    return new Promise((resolve) => {
      let lastImageInAnimationClass = '';
      if (window.matchMedia('(min-width: 750px)').matches) {
        lastImageInAnimationClass = '.nc-multi-image-cta__image--desktop-1-6';
      } else {
        lastImageInAnimationClass = '.nc-multi-image-cta__image--mobile-1-4';
      }

      const myCallback = () => {
        this.querySelector(lastImageInAnimationClass).removeEventListener('transitionend', myCallback);
        resolve(true);
      };

      // when animation on the last image is done, resolve Promise, so you can get back and start next animation
      this.querySelector(lastImageInAnimationClass).addEventListener('transitionend', myCallback);
      this.classList.add('nc-multi-image-cta--animate-show');
    });
  }
  async positionItemsAnimation() {
    return new Promise((resolve) => {
      let randomImageClass = '';
      if (window.matchMedia('(min-width: 750px)').matches) {
        randomImageClass = '.nc-multi-image-cta__image--desktop-1-6';
      } else {
        randomImageClass = '.nc-multi-image-cta__image--mobile-1-4';
      }

      const myCallback = () => {
        this.querySelector(randomImageClass).removeEventListener('animationend', myCallback);
        resolve(true);
      };

      // when animation on an image is done, resolve Promise, so you can get back and start next animation
      this.querySelector(randomImageClass).addEventListener('animationend', myCallback);
      this.classList.add('nc-multi-image-cta--animate-position');
    });
  }
}
customElements.define('nc-multi-image-cta', NcMultiImageCtaAnimation);
